import logIt from "../../../logIt";

const throttleByFunctionName = function (func, timeInSeconds, throttledFunctionName) {
    const me = this;
    return function (...args) {
        const functionName = throttledFunctionName || func.name || 'anonymous';
        logIt(
            `throttle check for function name: ${ApexChat.throttledFunctions[functionName]} check: ${functionName}`
        );

        if (!ApexChat.throttledFunctions[functionName]) {
            // Call the original function with provided arguments
            func.apply(this, args);

            // Set a timeout to reset the throttling after the specified time
            setTimeout(() => {
                ApexChat.throttledFunctions[functionName] = false;
            }, timeInSeconds * 1000);

            // Set the flag to indicate that the function is currently throttled
            ApexChat.throttledFunctions[functionName] = true;
        } else {
            logIt(`throttled!${ApexChat.throttledFunctions[functionName]}`);
        }
    };
};
export default throttleByFunctionName;
